import React from 'react'
import useDevelopersLoader from './lib/useDevelopersLoader'

import Loader from './components/Loader'
import DevelopersMap from './components/DevelopersMap'

import './App.css'

function App() {
  const { developers, loading } = useDevelopersLoader()

  return <div className="developer-map">
    {
      loading
      ? <Loader />
      : <DevelopersMap developers={ developers } />
    }
  </div>
}

export default App;
